import classNames from "classnames";
import _pick from "lodash/pick";
import React from "react";
import { useDispatch, useSelector as useReduxSelector } from "react-redux";
import { isOpenInNewTab } from "web/react/hooks/use-click-tracker/use-click-tracker";
import { setSelectedGender } from "web/redux/ducks/feed-sidebar";
import { ReduxStoreState } from "web/redux/store";
import { gettext } from "web/script/modules/django-i18n";
import { InputFilterOption } from "web/types/universal-filters";
import styles from "./feed-gender-switch.css";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function extractGenderState(state: ReduxStoreState) {
    return _pick(state.feedSidebarReducer, "genderOptions", "loading");
}

function blockHref(event: React.MouseEvent<HTMLAnchorElement>): void {
    event.preventDefault();
}

function FeedGenderSwitch(): JSX.Element | null {
    const { genderOptions, loading } = useReduxSelector(extractGenderState);
    const dispatch = useDispatch();

    function selectGender(
        option: InputFilterOption,
        event: React.MouseEvent<HTMLAnchorElement>
    ): void {
        if (isOpenInNewTab(event)) {
            return;
        }
        dispatch(setSelectedGender(option));
        event.preventDefault();
    }

    return (
        <div
            className={classNames(styles.genderSwitcher, {
                [styles.loading]: loading || genderOptions.length === 0,
            })}
        >
            <div className={styles.genderLabelWrapper}>
                <span className={styles.genderLabel}>
                    {// "You are browsing by:"
                    gettext("feed.filters.gender_switch_label")}
                </span>

                {(loading || genderOptions.length === 0) && (
                    <div className="loading-square loading-square--inline">
                        <div className="loading-square__lr"></div>
                        <div className="loading-square__tb"></div>
                    </div>
                )}
            </div>

            <span className={styles.genderOptions}>
                {genderOptions.map((option) => (
                    <a
                        key={option.value}
                        href={!loading ? option.url : "#"}
                        className={classNames(styles.genderOption, {
                            [styles.selected]: option.checked,
                        })}
                        onClick={!loading ? selectGender.bind(null, option) : blockHref}
                    >
                        {option.label}
                    </a>
                ))}
            </span>
        </div>
    );
}

export default FeedGenderSwitch;
